import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=672c8fda&scoped=true"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"
import style1 from "./DashboardLayout.vue?vue&type=style&index=1&id=672c8fda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c8fda",
  null
  
)

export default component.exports